/* eslint-disable react-hooks/exhaustive-deps */
import { formatTitleCompany } from '../../../../utils/formatTitleCompany'
import React, { useEffect, useState } from 'react'
import { Offcanvas, Spinner } from 'react-bootstrap'
import { RiCloseLine } from 'react-icons/ri'
import { Avatar } from '../../../icons/icons'
import PLACE_PLACEHOLDER from '../../../../utils/placePlaceholder'
import { GOOGLE_MAPS_API_KEY } from '../../../../utils/location/googleMapsLoader'
import ApiFunction from '../../../../utils/api/apiFuntions'
import { decryptData } from '../../../../utils/api/encrypted'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import getPlaceImageUrls, { initGooglePlaces } from '../../../../utils/location/googleImage'

const GOOGLE_PLACES_API_KEY = GOOGLE_MAPS_API_KEY;

const NearbyDrawer = ({ show, hide, userData }) => {
    const tags = userData?.tags || [];
    console.log("the UserData is ", userData);
    const [place_id, setPlaceId] = useState('');
    const [placeImage, setPlaceImage] = useState(null);
    const [imageLoading, setImageLoading] = useState(false);
    const [placesServiceReady, setPlacesServiceReady] = useState(false);
    const [initError, setInitError] = useState(null);
    const [interestsList, setInterestsList] = useState(null);
    const [showAll, setShowAll] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userInterest, setUserInterest] = useState([]);
    const [userLanguages, setUserLanguages] = useState([]);
    const [remainingTime, setRemainingTime] = useState(null);
    const [isCurrentUserCheckedIn, setIsCurrentUserCheckedIn] = useState(false);

    const visibleTags = showAll ? tags : tags.slice(0, 2);
    const hiddenTagsCount = tags.length - 2;
    const hiddenTags = tags.slice(2);
    const { post } = ApiFunction();
    
    // Get languages from Redux store (same as Profile component)
    const allLanguages = useSelector((state) => state.appData?.languages);

    // Check if current user is checked in
    useEffect(() => {
        const checkInData = localStorage.getItem('checkInData');
        if (checkInData) {
            try {
                const parsedData = JSON.parse(checkInData);
                const checkInTime = parsedData.checkInTime;
                const duration = parsedData.duration;

                if (checkInTime && duration) {
                    const checkInDate = new Date(checkInTime);
                    const expiryDate = new Date(checkInDate.getTime() + (duration * 60 * 1000));
                    const now = new Date();
                    setIsCurrentUserCheckedIn(now <= expiryDate);
                } else {
                    setIsCurrentUserCheckedIn(false);
                }
            } catch (error) {
                console.error('Error checking current user check-in:', error);
                setIsCurrentUserCheckedIn(false);
            }
        } else {
            setIsCurrentUserCheckedIn(false);
        }
    }, [show]); // Re-check when drawer opens

    // Calculate remaining time in real-time
    useEffect(() => {
        if (!userData?.check?.created_at || !userData?.check?.duration) {
            setRemainingTime(null);
            return;
        }

        const calculateRemainingTime = () => {
            const createdAt = new Date(userData.check.created_at);
            const durationMinutes = parseInt(userData.check.duration);
            const endTime = new Date(createdAt.getTime() + durationMinutes * 60 * 1000);
            const now = new Date();
            const diffMs = endTime - now;

            if (diffMs <= 0) {
                setRemainingTime('Check-in ended');
                return;
            }

            const totalMinutes = Math.floor(diffMs / (1000 * 60));
            const diffHours = Math.floor(totalMinutes / 60);
            const diffMinutes = totalMinutes % 60;

            if (diffHours > 0) {
                setRemainingTime(`${diffHours}h ${diffMinutes}m left`);
            } else if (diffMinutes > 0) {
                setRemainingTime(`${diffMinutes}m left`);
            } else {
                setRemainingTime('Less than 1m left');
            }
        };

        // Calculate immediately
        calculateRemainingTime();

        // Update every second
        const intervalId = setInterval(calculateRemainingTime, 1000);

        // Cleanup
        return () => clearInterval(intervalId);
    }, [userData?.check?.created_at, userData?.check?.duration]);

    // Initialize Google Places API when component mounts
    useEffect(() => {
        const initializePlaces = async () => {
            try {
                await initGooglePlaces(GOOGLE_PLACES_API_KEY);
                setPlacesServiceReady(true);
                setInitError(null);
            } catch (error) {
                setInitError(error.message);
                setPlacesServiceReady(false);
            }
        };

        if (GOOGLE_PLACES_API_KEY) {
            initializePlaces();
        } else {
            setInitError('API key not found');
        }
    }, []);

    // Extract place_id from userData
    useEffect(() => {
        if (userData?.check) {
            const extractedPlaceId = userData.check.place_id;

            if (extractedPlaceId && extractedPlaceId.trim() !== '') {
                setPlaceId(extractedPlaceId.trim());
            } else {
                setPlaceId('');
            }
        } else {
            setPlaceId('');
        }
    }, [userData]);

    // Fetch place image when conditions are met
    useEffect(() => {
        const fetchPlaceImage = async () => {

            if (!place_id) {
                return;
            }

            if (!placesServiceReady) {
                return;
            }

            if (initError) {
                return;
            }

            setImageLoading(true);

            try {
                const imageUrls = await getPlaceImageUrls(place_id);
                if (imageUrls && imageUrls.length > 0) {
                    setPlaceImage(imageUrls[0]);
                } else {
                    setPlaceImage(null);
                }
            } catch (error) {
                setPlaceImage(null);
            } finally {
                setImageLoading(false);
            }
        };

        fetchPlaceImage();
    }, [place_id, placesServiceReady, initError]);

    // Test place ID validation function
    const testPlaceId = (testId) => {
        // Google Place IDs typically start with specific prefixes
        const validPrefixes = ['ChIJ', 'EI', 'GhIJ'];
        const hasValidPrefix = validPrefixes.some(prefix => testId.startsWith(prefix));

        if (!hasValidPrefix) {
        } else {
        }

        return testId.length > 10;
    };

    // Test the current place_id
    useEffect(() => {
        if (place_id) {
            testPlaceId(place_id);
        }
    }, [place_id]);

    // Parse JSON strings with better error handling
    const parseJsonString = (jsonString, fieldName) => {
        if (!jsonString) {
            console.log(`No ${fieldName} found in userData`);
            return [];
        }

        try {
            console.log(`Raw ${fieldName} string:`, jsonString);

            // Remove all backslashes
            let cleanedString = jsonString.replace(/\\/g, '');
            console.log(`Cleaned ${fieldName} string:`, cleanedString);

            // Parse JSON
            const parsed = JSON.parse(cleanedString);
            console.log(`Parsed ${fieldName}:`, parsed);

            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error(`Error parsing ${fieldName}:`, error);
            return [];
        }
    };

    // Filter and set interests and languages
    useEffect(() => {
        if (!userData) {
            return;
        }

        // Parse and set interests
        const interestNames = parseJsonString(userData.interests, 'interests');
        if (interestNames?.length > 0) {
            const interestsArray = interestNames.map((name, idx) => ({
                id: `interest-${idx}`,
                name: name.trim()
            }));
            setUserInterest(interestsArray);
            console.log("Set user interests:", interestsArray);
        } else {
            setUserInterest([]);
        }

        // Parse and set languages with flags (matching Profile component logic)
        const languageNames = parseJsonString(userData.languages, 'languages');
        if (languageNames?.length > 0 && allLanguages?.length > 0) {
            // Match language names with the full language objects from Redux store
            const languagesArray = languageNames
                .map(name => {
                    // Find matching language object from allLanguages
                    const matchedLang = allLanguages.find(lang => 
                        lang.name.toLowerCase() === name.toLowerCase()
                    );
                    return matchedLang || { name: name.trim(), flag: null };
                })
                .filter(lang => lang !== null);
            
            setUserLanguages(languagesArray);
            console.log("Set user languages with flags:", languagesArray);
        } else if (languageNames?.length > 0) {
            // Fallback if allLanguages not available yet
            const languagesArray = languageNames.map((name, idx) => ({
                id: `language-${idx}`,
                name: name.trim(),
                flag: null
            }));
            setUserLanguages(languagesArray);
        } else {
            setUserLanguages([]);
        }

    }, [userData, interestsList, allLanguages]);

    useEffect(() => {
        const data = new FormData();
        data.append('type', 'get_data');
        data.append('table_name', 'interests');

        const getallInterest = async () => {
            try {
                const response = await post('', data);
                if (response?.data) {
                    console.log("Fetched interests from API:", response?.data);
                    setInterestsList(response?.data);
                }
            } catch (err) {
                console.error("Error fetching interests:", err);
            }
        }

        getallInterest();
    }, []);

    const encryptedToken = useSelector(state => state?.appData?.userToken);
    const userToken = decryptData(encryptedToken);
    const navigate = useNavigate();

    const startMessage = async () => {
        const data = {
            type: "start_personal_conversation",
            user_id: userToken,
            other_user_id: userData?.id
        }
        setLoading(true);
        await post('', data)
            .then(res => {
                if (res?.result) {
                    const conversation_id = res?.conversation_id;
                    navigate(`/private/${conversation_id}`, { state: { otherUser: userData } });
                }
            })
            .catch(err => {
                console.log("the error in private message is", err);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    if (!userData) {
        return null;
    }

    return (
        <>
            <Offcanvas backdropClassName="blurred-backdrop-offcanvas" show={show} placement='bottom' onHide={hide} className="offcanvas-bottom offcanvasBG">
                <Offcanvas.Body>
                    <RiCloseLine onClick={hide} className='w-[32px] h-[32px] bg-[#F5F7FA] rounded-full cursor-pointer absolute p-[6px] right-5 top-[25px]' />
                    <div className=' flex flex-col items-center pt-[20px] h-100 sm:px-[15px]'>
                        <div className=''>
                            <img src={userData?.image ? userData?.image : Avatar} className='mx-auto object-cover h-[96px] w-[96px] bg-[#ACCBFF] rounded-full' alt="" style={{ objectFit: 'cover', objectPosition: 'center' }} />
                        </div>
                        <div className='mt-4'>
                            <h1 className='britti_medium fs_24 text-center'>{userData?.name}</h1>
                            <h2 className='txt_grey fs_16 mt-2 text-center'>
                                {(() => {
                                    const t = (userData?.designation || '').trim();
                                    const c = (userData?.company || '').trim();
                                    const label = formatTitleCompany(t, c);
                                    if (!label) return userData?.email || null;
                                    if (t && c && label.includes(' · ')) {
                                        return <>{t} · <span className="text-[var(--primary)]">{c}</span></>;
                                    }
                                    if (t && c && label === t) return t;
                                    if (c && !t) return <span className="text-[var(--primary)]">{c}</span>;
                                    return label;
                                })()}
                            </h2>
                            {userData?.about ? (
                                <h3 className='text-[#525866] britti fs_16 my-4'>{userData?.about}</h3>
                            ) : null}
                        </div>

                        {/* Display Languages with Flags */}
                        {userLanguages && userLanguages?.length > 0 && (
                            <div className='mb-3 w-full'>
                                <span className='fs_16 text-left w-full text-[#525866]'>Languages</span>
                                <div className='w-full mt-1 interestsGroup items-center'>
                                    {userLanguages?.map((language, idx) => (
                                        <div
                                            key={language.id || idx}
                                            className="border border-[#E1E4EA] bg-[#fff] rounded-[12px] flex items-center justify-center gap-1 px-[15px] py-[6px] text-sm font-medium text-gray-700"
                                        >
                                            {language?.flag && (
                                                <img src={language?.flag} className='w-[16px] h-[16px] rounded-full object-cover' alt="" />
                                            )}
                                            <span className='flex items-center gap-[16px] top-[2px] relative'> {language?.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Display Interests */}
                        {userInterest && userInterest?.length > 0 && (
                            <div className='mb-3 w-full'>
                                <span className='fs_16 text-left w-full text-[#525866]'>Interests</span>
                                <div className='w-full mt-1 interestsGroup items-center'>
                                    {userInterest?.map((interest, idx) => (
                                        <div
                                            key={interest.id || idx}
                                            className="border border-[#E1E4EA] bg-white rounded-[12px] flex items-center justify-center px-[15px] py-[6px] text-sm font-medium text-gray-700"
                                        >
                                            {interest?.name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Display Tags */}
                        {tags && tags?.length > 0 && (
                            <div className='w-full mt-3 interestsGroup items-center justify-center'>
                                {visibleTags.map((interest, idx) => (
                                    <div key={idx} className="border border-[#E1E4EA] rounded-[12px] flex items-center justify-center px-[15px] py-[6px] text-sm font-medium text-gray-700">
                                        {interest}
                                    </div>
                                ))}
                                {!showAll && hiddenTagsCount > 0 && (
                                    <div
                                        onClick={() => setShowAll(true)}
                                        className="cursor-pointer border border-[#E1E4EA] bg-white rounded-[12px] px-[15px] py-[6px] text-sm font-medium text-gray-700"
                                    >
                                        +{hiddenTagsCount}
                                    </div>
                                )}

                                {showAll && hiddenTags.map((interest, idx) => (
                                    <div key={`hidden-${idx}`} className="border border-[#E1E4EA] rounded-[12px] flex items-center justify-center px-[15px] py-[6px] text-sm font-medium text-gray-700">
                                        {interest}
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className='w-full mt-[8px]'>
                            <span className='text-start text-[#525866] fs_16'>Currently checked in at</span>
                            <div className='checkIn_Detail_card mt-1'>
                                {imageLoading ? (
                                    <div className='rounded-[12px] w-[48px] h-[48px] flex items-center justify-center bg-gray-200'>
                                        <Spinner size='sm' animation="border" />
                                    </div>
                                ) : (
                                    <img
                                        src={placeImage || PLACE_PLACEHOLDER}
                                        className='rounded-[12px] w-[48px] h-[48px]'
                                        style={{ objectFit: 'cover', objectPosition: 'center', flexShrink: 0 }}
                                        alt={userData?.check?.address || "Place"}
                                        onError={(e) => {
                                            e.target.src = PLACE_PLACEHOLDER;
                                        }}
                                    />
                                )}
                                <div>
                                    <h1 className='fs_16 britti_bold'>{userData?.check?.place_name}</h1>
                                    <detail className='txt_grey fs_14'>
                                        {remainingTime || 'Calculating...'}
                                        {userData?.check?.status_text ? <> - {userData?.check?.status_text}</> : ""}
                                    </detail>
                                </div>
                            </div>
                        </div>

                        <div className="btnGroup grid grid-cols-1 w-full gap-2 mt-4">
                            {isCurrentUserCheckedIn ? (
                                <button onClick={() => startMessage()} className='primary_btn w-full rounded-[12px]' disabled={loading}>
                                    {loading ? <><Spinner size='sm' animation="border" variant="light" /></> : "Send Message"}
                                </button>
                            ) : (
                                <div className='text-center py-3 bg-[#F9FAFB] rounded-[12px] border border-[#E5E7EB]'>
                                    <p className='text-[#6B7280] fs_14 mb-0'>Check-in to send messages</p>
                                </div>
                            )}
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default NearbyDrawer